/* eslint-disable react-hooks/rules-of-hooks */
// import React from 'react'
import React from "react";
import { Input, Button, Modal } from "antd";
import TableTemplete from "../../../components/table/TableTemplete";
import { getLotteryPolymerizeList } from "./service";
import { openModal as createEditModal } from "./component/EditPeopleModal";
import { openModal as codeModal } from "./component/codeModal";
import styles from "./index.module.less";

const goodsRoot = () => {
  const [modalVisible, changeModalVisible] = React.useState(false);
  const [searchParams, changeSearchParams] = React.useState({});
  const tableTempleteRef = React.useRef();

  React.useEffect(() => {
    onSearch();
  }, []);

  const onSearch = () => {
    tableTempleteRef.current.onSearch(searchParams);
  };

  const handleEditPreWinning = (record) => {
    createEditModal({ initData: record }).success(() => {
      onSearch();
    });
  };

  return (
    <div className={styles.lotteryAction}>
      <div
        className={styles.action}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          {/* <Button type="primary" onClick={handleAdd}>
            新增
          </Button> */}
        </div>
        <Input.Search
          style={{ width: 260 }}
          placeholder="活动名称"
          value={searchParams.keyWord}
          onChange={(e) => {
            changeSearchParams({ ...searchParams, keyWord: e.target.value });
          }}
          onSearch={onSearch}
        />
      </div>
      <TableTemplete
        setColumns={(columns) => {
          console.log("columns", columns);
          const newColumns = columns.map((ele) => {
            let newEle = { ...ele };
            if (newEle.dataIndex === "preLotteryPeople") {
              newEle = {
                ...ele,
                render: (text, record) => {
                  return (
                    <div className={styles["table-winningList"]}>
                      {record.preWinningList?.map((curr) => (
                        <div
                          key={curr.id}
                          className={styles["table-winningList-item"]}
                        >
                          <img
                            src={curr.avatarUrl}
                            alt="头像"
                            className={styles["table-winningList-item-icon"]}
                          />
                          <span
                            className={styles["table-winningList-item-text"]}
                          >
                            {curr.nickName}
                          </span>
                        </div>
                      ))}
                    </div>
                  );
                },
              };
            }
            if (newEle.dataIndex === "lotteryPeople") {
              newEle = {
                ...ele,
                render: (text, record) => {
                  return (
                    <div className={styles["table-winningList"]}>
                      {record.winningList?.map((curr) => (
                        <div
                          key={curr.id}
                          className={styles["table-winningList-item"]}
                        >
                          <img
                            src={curr.avatarUrl}
                            alt="头像"
                            className={styles["table-winningList-item-icon"]}
                          />
                          <span
                            className={styles["table-winningList-item-text"]}
                          >
                            {curr.nickName}
                          </span>
                        </div>
                      ))}
                    </div>
                  );
                },
              };
            }
            return newEle;
          });
          return newColumns;
        }}
        tableRef={tableTempleteRef}
        searchService={getLotteryPolymerizeList}
        tableProps={{
          style: { marginTop: 8 },
          rowKey: "id",
          // scroll: {
          //   x: 1200,
          //   y: 600
          // }
        }}
        operateColumn={{
          title: "操作",
          width: 180,
          render: (text, record) => {
            return [
              (record.lotteryStatus === 1 || record.lotteryStatus === 2) && (
                <a
                  onClick={handleEditPreWinning.bind(this, record)}
                  className="action-btn"
                >
                  指定参与
                </a>
              ),
              // <a onClick={handleCode.bind(this, record)} className="action-btn">
              //   条码维护
              // </a>,
              // <a onClick={handleDel.bind(this, record)} className="action-btn">
              //   删除
              // </a>,
            ];
          },
        }}
        editColumn={{
          goodsCodeName: (text, record) => {
            return record.codes.map((item, index) => (
              <div key={item.goodsCode}>
                <a
                  onClick={handleDelCode.bind(this, {
                    ...record,
                    goodsCode: item.goodsCode,
                  })}
                >
                  删除
                </a>
                &nbsp;&nbsp;
                <span>{item.goodsCode}</span>
              </div>
            ));
          },
        }}
      />
    </div>
  );
};

export default goodsRoot;
